import CheckboxComponent, { CheckboxComponentProps } from './CheckboxComponent';
export default CheckboxComponent;
export type { CheckboxComponentProps };
